











import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import { Platforms } from '@/templates/Tree';

@Component({
  components: {
    DocIcon,
  },
  filters: {
    transformPlatformName: (name: string): string => {
      const platformNames: { [k: string]: string } = {
        safari: 'Safari',
        chrome: 'Chrome',
        firefox: 'Firefox',
        android: 'Android',
        ios: 'IOS',
      };

      return platformNames[name];
    },
  },
})
export default class PlatformSpecification extends Vue {
  @Prop(Object) platform: Platforms;
}
